import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import TableComp from '../../../components/_utils/table'
import {Card} from 'antd'
import Request from '../../../request'
import {connect} from 'react-redux'


class AllGlobalExpoLeads extends Component {

    state = {
        count: 0,
    }

    apiRequest = (params, columns) => {
        return new Promise(async resolve => {
            let data = await Request.getAllGlobalExpoLeads({
                ...params,
                regExFilters: ['applicantName']
            })
            this.setState({count: data.total})
            resolve(data)
        })
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    async componentDidMount() {
        
    }

    render() {

        const columns = [ ]
        return (
            <PageHeaderWrapper title={` Global Expo Leads : ${this.state.count} `}>

                <Card bordered={true}>
                    <TableComp
                        showSelector={true}
                        columns={columns}
                        ref={this.table}
                        apiRequest={params => this.apiRequest(params, columns)}
                        extraProps={{scroll: {x: 1500}}}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global}) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllGlobalExpoLeads)
